import React from 'react';

const footer = () => {
    return (
        <footer>
            <div className="row">
                <div className="twelve columns">
                    <ul className="social-links">
                        <li><a href="https://github.com/lukejsimonetti"><i className="fa fa-github" /></a></li>
                        <li><a href="https://stackoverflow.com/users/3321344/lsimonetti"><i className="fa fa-stack-overflow" /></a></li>
                    </ul>
                    <ul className="copyright">
                        <li>&copy; Copyright 2014 CeeVee</li>
                        <li>Design by <a title="Styleshout" href="http://www.styleshout.com/">Styleshout</a></li>
                    </ul>
                </div>
                <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
            </div>
        </footer>
    )
}

export default footer


// WEBPACK FOOTER //
// ./src/main/footer.js